import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect } from 'react-router-dom';
import { logout } from '../actions/AppActions';
import { connect } from 'react-redux';

class ProfileMenu extends Component {
    constructor(props) {
        super(props);
        this.state = { menu: false, redirect: false, path: '/' };
        this.toggle = this.toggle.bind(this);
    }
    toggle() { this.setState(prevState => ({ menu: !prevState.menu })); }
    logout() { localStorage.removeItem('token'); this.props.logout(); }
    render() {
        let t = this.props.t || {};
        return (
            <React.Fragment>
                {this.state.redirect === true && <Redirect to={this.state.path} />}
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block avaliador-profile-menu">
                    <DropdownToggle className="btn header-item waves-effect avaliador-profile-toggle" id="page-header-user-dropdown" tag="button"><span className="avaliador-profile-meta"><strong>{this.props.user?.name || 'Usuário'}</strong><small>{this.props.user?.email || 'OnTest'}</small></span><span className="header-profile-user avaliador-profile-placeholder" aria-label="Perfil do usuário"><i className="mdi mdi-account"></i></span></DropdownToggle>
                    <DropdownMenu right className="avaliador-profile-dropdown"><DropdownItem tag="a" className="avaliador-profile-logout" onClick={this.logout.bind(this)}><i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>{t.logout || 'Logout'}</DropdownItem></DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}
const mapsStateToProps = (state) => ({ user: state.AppReducer.user || {} });
export default withRouter(connect(mapsStateToProps, { logout })(ProfileMenu));
